// extracted by mini-css-extract-plugin
export default {"navbar":"header_navbar__oTmqf","background":"header_background__VCuqr","h1Home":"header_h1Home__KA3Ww","h3Home":"header_h3Home__q3cr5","btnHome":"header_btnHome__hz+Hp"};